<i18n lang="json">
{
  "ru": {
    "safe deposit box": "Кто может арендовать банковскую ячейку?",
    "residents of Abkhazia": "Резиденты Абхазии",
    "Renting is possible with a passport.": "аренда возможна по паспорту.",
    "Citizens of the RF": "Граждане РФ",
    "Citizens of the RF_content": "для оформления необходим внутренний паспорт с пропиской.",
    "safe_boxes_info": "Банковские ячейки – это удобное и надежное решение для тех, кто ценит безопасность и спокойствие.",
    "safe_boxes_contact": "Для получения более подробной информации о тарифах и условиях аренды обращайтесь в контакт-центр"
  },
  "en": {
    "safe deposit box": "Who can rent a safe deposit box?",
    "residents of Abkhazia": "Residents of Abkhazia",
    "Renting is possible with a passport.": "Renting is possible with a passport.",
    "Citizens of the RF": "Citizens of the Russian Federation",
    "Citizens of the RF_content": "An internal passport with registration is required for registration.",
    "safe_boxes_info": "Safe deposit boxes are a convenient and reliable solution for those who value security and peace of mind.",
    "safe_boxes_contact": "For more information about rental rates and terms, please contact our customer service center"
  },
  "tr": {
    "safe deposit box": "Kimler kiralık kasa kiralayabilir?",
    "residents of Abkhazia": "Abhazya sakinleri",
    "Renting is possible with a passport.": "Pasaport ile kiralama mümkündür.",
    "Citizens of the RF": "Rusya Federasyonu vatandaşları",
    "Citizens of the RF_content": "Kayıt için tescilli bir dahili pasaport gereklidir.",
    "safe_boxes_info": "Banka kasaları, güvenlik ve huzura önem verenler için pratik ve güvenilir bir çözümdür.",
    "safe_boxes_contact": "Kira ücretleri ve koşulları hakkında daha fazla bilgi için lütfen çağrı merkezimize başvurun"
  },
  "es": {
    "safe deposit box": "¿Quién puede alquilar una caja de seguridad?",
    "residents of Abkhazia": "Residentes de Abjasia",
    "Renting is possible with a passport.": "Se puede alquilar con pasaporte.",
    "Citizens of the RF": "Ciudadanos de la Federación Rusa.",
    "Citizens of the RF_content": "Para el registro se requiere un pasaporte interno con registro.",
    "safe_boxes_info": "Las cajas de seguridad son una solución cómoda y confiable para quienes valoran la seguridad y la tranquilidad.",
    "safe_boxes_contact": "Para obtener más información sobre tarifas y condiciones de alquiler, comuníquese con nuestro centro de atención al cliente"
  },

  "ar": {
    "safe deposit box": "من يمكنه استئجار صندوق ودائع آمن؟",
    "residents of Abkhazia": "سكان أبخازيا",
    "Renting is possible with a passport.": "الإيجار ممكن مع جواز السفر.",
    "Citizens of the RF": "مواطني الاتحاد الروسي",
    "Citizens of the RF_content": "مطلوب جواز سفر داخلي مع التسجيل للتسجيل.",
    "safe_boxes_info": "الخزائن المصرفية هي حل مريح وموثوق لأولئك الذين يقدرون الأمان وراحة البال.",
    "safe_boxes_contact": "للحصول على مزيد من المعلومات حول الأسعار وشروط الإيجار، يرجى الاتصال بمركز خدمة العملاء"
  }
}
</i18n>

<template>
  <section class="pt-8 sm:pt-[60px] mb-10 lg:mb-24">
    <div class="container px-4 lg:px-0">
      <p class="font-medium text-xl sm:text-3xl">{{ t("safe deposit box") }}</p>
      <div
        class="mt-5 flex flex-col sm:mt-11 md:grid gap-[10px] md:grid-cols-12"
      >
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="
            index % 2 === 0
              ? 'md:col-start-1 md:col-span-5'
              : 'md:col-start-7 md:col-span-6'
          "
          class="flex gap-[14px]"
        >
          <div
            class="h-9 md:h-[58px] w-9 md:w-[58px] bg-[#FCC900] rounded-full relative aspect-square"
            style="flex-shrink: 0"
          >
            <p
              class="font-semibold text-base md:text-xl flex justify-center p-[10px] md:p-[18px]"
            >
              {{ index + 1 }}
            </p>
          </div>
          <div>
            <p class="text-base sm:text-3xl mt-1 md:mt-4">
              {{ t(item.title) }}
            </p>
            <div v-if="item.subItems" class="grid gap-[10px] mt-2 sm:mt-6">
              <div
                v-for="(subItem, subIndex) in item.subItems"
                :key="subIndex"
                class="flex gap-[7px] items-center"
              >
                <div
                  class="w-3 h-3 bg-[#FCC900] rounded-full"
                  style="flex-shrink: 0"
                ></div>
                <p class="text-sm sm:text-base" v-html="t(subItem)"></p>
              </div>
            </div>
            <div v-else class="flex gap-[7px] items-center mt-2 sm:mt-6">
              <div
                class="w-3 h-3 bg-[#FCC900] rounded-full"
                style="flex-shrink: 0"
              ></div>
              <p v-html="t(item.content)" class="text-sm sm:text-base"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 sm:mt-6 text-sm sm:text-lg">
        <p>{{ t("safe_boxes_info") }}</p>
        <p>{{ t("safe_boxes_contact") }}: +7 840 227-73-35.</p>
      </div>
    </div>
  </section>
</template>

<script setup>
const { t } = useI18n({ useScope: "local" });
const items = [
  {
    title: "residents of Abkhazia",
    subItems: ["Renting is possible with a passport."],
  },
  {
    title: "Citizens of the RF",
    content: "Citizens of the RF_content",
  },
];
</script>
